import api from "@/api/tests";

export default {
  state: {
    tests: null,
    testId: null,
    result: null,
    isResult: null,
    errorsCount: null,
  },
  getters: {
    getTests: (state) => state.tests,
    getTestId: (state) => state.testId,
    getTestResultsById: (state) => (id) => state.result[id],
    getIsTestResult: (state) => state.isResult,
    getTestErrorsCount: (state) => state.errorsCount,
    getTestAttempts: (state) => state.attempts
  },
  mutations: {
    SET_QUESTIONS(state, payload) {
      const data  = payload.map((item) => {
        item.options = JSON.parse(item.options);
        return item;
      });
      state.tests = data;
    },
    SET_TEST_ID(state, payload) {
      state.testId = payload;
    },
    SET_TEST_RESULTS(state, payload) {
      state.result = payload;
      state.isResult = true;
    },
    SET_TEST_ERRORS_COUNT(state, payload) {
      state.errorsCount = payload;
    },
    SET_TEST_ATTEMPTS(state, payload) {
      state.attempts = payload;
    },
    CLEAR_TEST_RESULTS(state) {
      state.result = null;
      state.isResult = false;
      state.errorsCount = null;
    },
    CLEAR_TEST_DATA(state) {
      state.tests = null;
      state.testId = null;
    }
  },
  actions: {
    fetchTestsById({ commit }, payload) {
      commit("CLEAR_TEST_DATA");
      api.getTestsById(payload).then(
        ({
          data: {
            data: {
              questions,
              additional
            }
          },
          status
        }) => {
          if (status === 200) {
            commit("SET_QUESTIONS", questions);
            commit("SET_RESULTS", additional);
          }
        }
      );
    },
    postTest({ commit, dispatch }, payload) {
      dispatch("setIsLoadingData", true);
      api
        .saveTest(payload)
        .then(
          ({
            data: {
              data: {
                answers: { results, errors_count }
              }
            }
          }) => {
            commit("SET_TEST_RESULTS", results);
            commit("SET_TEST_ERRORS_COUNT", errors_count);
          }
        )
        .finally(() => {
          dispatch("setIsLoadingData", false);
        });
    },
    clearTestResultsData({ commit }) {
      commit("CLEAR_TEST_RESULTS");
    }
  }
};
